"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.driverBase = void 0;
const compact_1 = __importDefault(require("lodash/compact"));
const SqlDumper_1 = require("./SqlDumper");
const dbgate_query_splitter_1 = require("dbgate-query-splitter");
const dbgate_sqltree_1 = require("dbgate-sqltree");
const dialect = {
    limitSelect: true,
    rangeSelect: true,
    offsetFetchRangeSyntax: true,
    stringEscapeChar: "'",
    fallbackDataType: 'nvarchar(max)',
    quoteIdentifier(s) {
        return s;
    },
    columnProperties: {
        isSparse: false,
        isPersisted: false,
    },
    defaultSchemaName: null,
};
exports.driverBase = {
    analyserClass: null,
    dumperClass: SqlDumper_1.SqlDumper,
    dialect,
    databaseEngineTypes: ['sql'],
    supportedCreateDatabase: true,
    analyseFull(pool, version) {
        return __awaiter(this, void 0, void 0, function* () {
            const analyser = new this.analyserClass(pool, this, version);
            return analyser.fullAnalysis();
        });
    },
    analyseSingleObject(pool, name, typeField = 'tables') {
        return __awaiter(this, void 0, void 0, function* () {
            const analyser = new this.analyserClass(pool, this);
            return analyser.singleObjectAnalysis(name, typeField);
        });
    },
    analyseSingleTable(pool, name) {
        return this.analyseSingleObject(pool, name, 'tables');
    },
    analyseIncremental(pool, structure, version) {
        return __awaiter(this, void 0, void 0, function* () {
            const analyser = new this.analyserClass(pool, this, version);
            return analyser.incrementalAnalysis(structure);
        });
    },
    createDumper(options = null) {
        return new this.dumperClass(this, options);
    },
    script(pool, sql) {
        return __awaiter(this, void 0, void 0, function* () {
            for (const sqlItem of (0, dbgate_query_splitter_1.splitQuery)(sql, this.getQuerySplitterOptions('script'))) {
                yield this.query(pool, sqlItem, { discardResult: true });
            }
        });
    },
    getNewObjectTemplates() {
        if (this.databaseEngineTypes.includes('sql')) {
            return [{ label: 'New view', sql: 'CREATE VIEW myview\nAS\nSELECT * FROM table1' }];
        }
        return [];
    },
    loadFieldValues(pool, name, columnName, search) {
        return __awaiter(this, void 0, void 0, function* () {
            const dmp = this.createDumper();
            const select = {
                commandType: 'select',
                distinct: true,
                topRecords: 100,
                from: {
                    name,
                },
                columns: [
                    {
                        exprType: 'column',
                        columnName,
                        alias: 'value',
                    },
                ],
                orderBy: [
                    {
                        exprType: 'column',
                        columnName,
                    },
                ],
            };
            if (search) {
                const tokens = (0, compact_1.default)(search.split(' ').map(x => x.trim()));
                if (tokens.length > 0) {
                    // @ts-ignore
                    select.where = {
                        conditionType: 'and',
                        conditions: tokens.map(token => ({
                            conditionType: 'like',
                            left: {
                                exprType: 'column',
                                columnName,
                            },
                            right: {
                                exprType: 'value',
                                value: `%${token}%`,
                            },
                        })),
                    };
                }
            }
            // @ts-ignore
            (0, dbgate_sqltree_1.dumpSqlSelect)(dmp, select);
            const resp = yield this.query(pool, dmp.s);
            return resp.rows;
        });
    },
    readJsonQuery(pool, select, structure) {
        const dmp = this.createDumper();
        (0, dbgate_sqltree_1.dumpSqlSelect)(dmp, select);
        return this.readQuery(pool, dmp.s, structure);
    },
    showConnectionField: (field, values) => false,
    showConnectionTab: (field) => true,
};
